import { RouterConfig } from "@clairejs/client";
import App from "./pages/App";

export const routes: RouterConfig = {
    path: "",
    component: { view: App },
};
